import * as React from "react";
import { Chart } from "react-google-charts";
 
 class PieCharts extends React.Component {
  render() {
    return (
      <div className={"my-pretty-chart-container"}>

<Chart
  width={'100%'}
 height={'350px'}
  chartType="PieChart"
  loader={<div>Loading Chart</div>}
  data={this.props.data}
  options={{
    title: this.props.heading,
    colors: ['#4FA4D1', '#F56C81','#745EF2','#AB8CE4', '#E4E4E4', '#2196F3'],
    //legend: 'none',
  //  pieSliceText: 'label',
    // Just add this option
    is3D: true,
  }}
  rootProps={{ 'data-testid': '2' }}
//   chartWrapperParams={{ view: { columns: [0, 3] } }}
/>
            <div hidden={this.props.IsNoData}><i className="fa fa-exclamation-triangle" style={{marginRight:"5px"}} aria-hidden="true"></i>No Data Available</div>

      </div>
    );
  }
}
export {PieCharts as default}

// render(<App />, document.querySelector("#app"));